/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_AdjustmentInputs */

const en_create_adjustment = /** @type {(inputs: Create_AdjustmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Adjustment`)
};

const es_create_adjustment = /** @type {(inputs: Create_AdjustmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear ajuste`)
};

/**
* | output |
* | --- |
* | "Create Adjustment" |
*
* @param {Create_AdjustmentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const create_adjustment = /** @type {((inputs?: Create_AdjustmentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_AdjustmentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_adjustment(inputs)
	return es_create_adjustment(inputs)
});